import { render, staticRenderFns } from "./AppConfigurationListForm.vue?vue&type=template&id=b971b376&scoped=true&"
import script from "./AppConfigurationListForm.vue?vue&type=script&lang=js&"
export * from "./AppConfigurationListForm.vue?vue&type=script&lang=js&"
import style0 from "./AppConfigurationListForm.vue?vue&type=style&index=0&id=b971b376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b971b376",
  null
  
)

export default component.exports